import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';
import CustomerContactInfoCompSelect from "./CustomerContactInfoCompSelect";
import phoneCodes from "../../utils/data/countryPhoneCodes.json";

const CustomerContactInfoPhoneCode = props => {
  const createSelectOptionsFromValue = value => ({text: value.replace('00', '+'), value: value.replace('00', '')});
  const phoneCodesList = phoneCodes.map(createSelectOptionsFromValue);

  return (
    <CustomerContactInfoCompSelect
      {...props}
      clearable={false}
      errorMessages={{
        'field_is_required': 'The dial code field is required',
        'field_is_invalid': 'Your dial code selection is invalid',
      }}
      label=""
      name="phoneCode"
      inputName="phoneCode"
      options={phoneCodesList}
      value={props.order.customer.phoneCode ?? ''}
    />
)};

export default CustomerContactInfoPhoneCode;
